export default {
    message: {
        impersonation: "Você está fazendo um pedido em nome de «{name}»"
    }
}